import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSolarPanel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSolarPanel"><Path d="M13.0008 8H19.8201L18.8479 3H13.0008V8Z" fill="currentColor"/><Path d="M11.0008 10V15H2.82031L3.79253 10H11.0008Z" fill="currentColor"/><Path d="M13.0008 15H11.0008V19H4.00077V21H20.0008V19H13.0008V15Z" fill="currentColor"/><Path d="M13.0008 15V10H20.209L21.1812 15H13.0008Z" fill="currentColor"/><Path d="M11.0008 8V3H5.15365L4.18142 8H11.0008Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSolarPanel;
